import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: '#06d6d6',
    },
    mywhite: {
      main: '#fff'
    }
  },
});
